export const seatStatuses = {
  7619: true,
  7620: true,
  7621: true,
  7622: true,
  7623: true,
  7624: true,
  7625: true,
  7626: true,
  7627: true,
  7628: false,
  7629: false,
  7630: true,
  7631: true,
  7632: true,
  7633: true,
  7634: true,
  7635: true,
  7636: true,
  7637: true,
  7638: true,
  7639: true,
  7640: true,
  7641: true,
  7642: true,
  7643: true,
  7644: true,
  7645: true,
  7646: true,
  7647: true,
  7648: true,
  7649: true,
  7650: true,
  7651: true,
  7652: true,
  7653: true,
  7654: true,
  7655: true,
  7699: true,
  7700: true,
  7701: true,
  7702: true,
  7703: true,
  7704: true,
  7705: true,
  7706: true,
  7707: true,
  7708: true,
  7709: true,
  7710: true,
  7711: false,
  7712: false,
  7713: true,
  7714: false,
  7715: false,
  7716: false,
  7717: true,
  7718: true,
  7719: true,
  7720: true,
  7721: true,
  7722: true,
  7723: true,
  7724: true,
  7725: true,
  7726: true,
  7727: true,
  7728: false,
  7729: false,
  7730: false,
  7731: false,
  7732: true,
  7733: true,
  7734: false,
  7735: false
};
